module.exports = __webpack_public_path__ + "img/VALOR_TRANSPARENCIA1.e4987c42.png";